/**
 * First-visit How the Harbour works prefs. Per account so shared browsers
 * do not mix “Don’t show again”.
 */

export const HARBOUR_HOW_IT_WORKS_PREFS_KEY_PREFIX = 'harbour.howItWorks'

const getStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null
  }
  return window.localStorage
}

/**
 * @param {string|null|undefined} accountId
 * @returns {string|null}
 */
export function buildHarbourHowItWorksStorageKey(accountId) {
  const id = String(accountId || '').trim()
  if (!id) {
    return null
  }
  return `${HARBOUR_HOW_IT_WORKS_PREFS_KEY_PREFIX}.${id}`
}

export function isHarbourHowItWorksDismissed(
  accountId,
  storage = getStorage(),
) {
  const key = buildHarbourHowItWorksStorageKey(accountId)
  if (!key || !storage) {
    return false
  }

  try {
    const raw = storage.getItem(key)
    if (!raw) {
      return false
    }
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return false
    }
    return Boolean(parsed.dismissed)
  } catch {
    return false
  }
}

export function setHarbourHowItWorksDismissed(
  accountId,
  dismissed,
  storage = getStorage(),
) {
  const key = buildHarbourHowItWorksStorageKey(accountId)
  if (!key || !storage) {
    return false
  }

  try {
    storage.setItem(key, JSON.stringify({ dismissed: Boolean(dismissed) }))
    return true
  } catch {
    return false
  }
}
